import { World } from '$legacyecstatic';
import { Components } from '../components';
import {
  addKeyboardEvents,
  addKeyboardEventsComponents,
} from './addKeyboardEvents';
import { addSheetEvents, addSheetEventsComponents } from './addSheetEvents';
import { configureCursor, configureCursorComponents } from './configureCursor';
import {
  configureDOMOverlay,
  configureDOMOverlayComponents,
} from './configureDOMOverlay';
import {
  configureOverlay,
  configureOverlayComponents,
} from './configureOverlay';
import { configureTool, configureToolComponents } from './configureTool';
import { focusedMarkupComponents, focusViewport } from './focusViewport';
import { manageSheet, manageSheetComponents } from './manageSheet';
import {
  moveBoxControlPoint,
  moveBoxControlPointComponents,
} from './moveBoxControlPoint';
import {
  moveLineControlPoint,
  moveLineControlPointComponents,
} from './moveLineControlPoint';
import { moveMarkup, moveMarkupComponents } from './moveMarkup';
import {
  renderControlPoints,
  renderControlPointsComponents,
} from './renderControlPoints';
import { renderLink, renderLinkComponents } from './renderLink';
import { renderMarkup, renderMarkupComponents } from './renderMarkup';
import { renderRemoveBtn, renderRemoveBtnComponents } from './renderRemoveBtn';
import { renderSpace, renderSpaceComponents } from './renderSpace';
import { renderTempRect, renderTempRectComponents } from './renderTempRect';
import { renderTileZoom, renderTileZoomComponents } from './renderTileZoom';
import { updateText, updateTextComponents } from './updateText';
import { updateZoom, updateZoomComponents } from './updateZoom';
import { updateZooming, updateZoomingComponents } from './updateZooming';

class Systems {
  world: World<Components>;

  constructor(world: World<Components>) {
    this.world = world;

    // Create systems. Order is Important
    this.world
      .addSystem(manageSheetComponents, manageSheet)
      .addSystem(addSheetEventsComponents, addSheetEvents)
      .addSystem(addKeyboardEventsComponents, addKeyboardEvents)
      .addSystem(configureOverlayComponents, configureOverlay)
      .addSystem(configureDOMOverlayComponents, configureDOMOverlay)
      .addSystem(configureToolComponents, configureTool)
      .addSystem(updateZoomComponents, updateZoom)
      .addSystem(updateZoomingComponents, updateZooming)
      .addSystem(renderSpaceComponents, renderSpace)
      .addSystem(renderTileZoomComponents, renderTileZoom)
      .addSystem(moveBoxControlPointComponents, moveBoxControlPoint)
      .addSystem(moveLineControlPointComponents, moveLineControlPoint)
      .addSystem(moveMarkupComponents, moveMarkup)
      .addSystem(renderMarkupComponents, renderMarkup)
      .addSystem(renderControlPointsComponents, renderControlPoints)
      .addSystem(updateTextComponents, updateText)
      .addSystem(renderTempRectComponents, renderTempRect)
      .addSystem(focusedMarkupComponents, focusViewport)
      .addSystem(renderRemoveBtnComponents, renderRemoveBtn)
      .addSystem(configureCursorComponents, configureCursor);
  }

  run = (): void => {
    this.world.systems.run();
  };
}

export function addEditorSystems(world: World<Components>): void {
  world
    .addSystem(manageSheetComponents, manageSheet)
    .addSystem(addSheetEventsComponents, addSheetEvents)
    .addSystem(addKeyboardEventsComponents, addKeyboardEvents)
    .addSystem(configureOverlayComponents, configureOverlay)
    .addSystem(configureDOMOverlayComponents, configureDOMOverlay)
    .addSystem(configureToolComponents, configureTool)
    .addSystem(updateZoomComponents, updateZoom)
    .addSystem(updateZoomingComponents, updateZooming)
    .addSystem(renderSpaceComponents, renderSpace)
    .addSystem(renderTileZoomComponents, renderTileZoom)
    .addSystem(moveBoxControlPointComponents, moveBoxControlPoint)
    .addSystem(moveLineControlPointComponents, moveLineControlPoint)
    .addSystem(moveMarkupComponents, moveMarkup)
    .addSystem(renderLinkComponents, renderLink)
    .addSystem(renderMarkupComponents, renderMarkup)
    .addSystem(renderControlPointsComponents, renderControlPoints)
    .addSystem(updateTextComponents, updateText)
    .addSystem(renderTempRectComponents, renderTempRect)
    .addSystem(focusedMarkupComponents, focusViewport)
    .addSystem(renderRemoveBtnComponents, renderRemoveBtn)
    .addSystem(configureCursorComponents, configureCursor);
}

export default Systems;
